export default __webpack_public_path__ + "static/media/tripadvisor.b3b4a6d2.svg";